import { combineReducers } from 'redux'
import { createReducer } from 'helpers/ReducerUtil'
import { getWeekAndYearBasedonDuration } from 'helpers/DateUtil'

import {
  CLEAR_SKU,
  UPDATE_SKU,
  UPDATE_SEARCH,
  CLEAR_SEARCH,
  CLEAR_TABLE_FILTER,
  UPDATE_TABLE_FILTER,
  CLEAR_TABLE_SORT,
  UPDATE_TABLE_SORT,
  UPDATE_REPORT_DURATION
} from './constants'
import * as R from 'ramda'
import P from 'helpers/predicates'


const emptyString = () => ''
const emptyObject = () => ({})
const updateValue = (prev, { value }) => P.isNotNil(value) ? value : prev

const defaultReportDuration = () => {
  return {
    value: 'week',
    week: getWeekAndYearBasedonDuration('week').week,
    year: getWeekAndYearBasedonDuration('week').year,
  }
}

const updateReportDuration = (prev, { value }) => 
  ({ ...prev, 
    value: value,
    week: getWeekAndYearBasedonDuration(value).week,
    year: getWeekAndYearBasedonDuration(value).year,
  
  })

const sku = createReducer(emptyString(), {
  [CLEAR_SKU]: emptyString,
  [UPDATE_SKU]: updateValue
})

const search = createReducer(emptyString(), {
  [CLEAR_SEARCH]: emptyString,
  [UPDATE_SEARCH]: updateValue
})

const tableFilter = createReducer(emptyObject(), {
  [CLEAR_TABLE_FILTER]: emptyObject,
  [UPDATE_TABLE_FILTER]: updateValue
})

const tableSort = createReducer(emptyObject(), {
    [CLEAR_TABLE_SORT]: emptyObject,
    [UPDATE_TABLE_SORT]: updateValue
})

const reportDuration = createReducer(defaultReportDuration(), {
  [UPDATE_REPORT_DURATION]: updateReportDuration
})

export default combineReducers({
  sku,
  reportDuration,
  search,
  tableFilter,
  tableSort,
})
